import { useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Resident avatar. Falls back to an initials badge if no photo.
 * Pass `bust` (e.g. photo_updated_at) to force cache refresh after upload.
 */
export default function StudentAvatar({ student, size = 36, className = "" }) {
  const [errored, setErrored] = useState(false);
  // Prefer Cloudinary direct URL; fallback to backend-served Emergent photo; else initials.
  let src = null;
  if (student?.photo_url && !errored) {
    src = student.photo_url;
  } else if (student?.photo_path && !errored) {
    src = `${BACKEND_URL}/api/students/${student.id}/photo?v=${encodeURIComponent(student.photo_updated_at || "")}`;
  }
  const initials = (student?.name || "?").trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("");

  return (
    <div
      className={`relative rounded-full overflow-hidden bg-[#E8C2B8] text-[#8C3F2C] inline-flex items-center justify-center font-medium ${className}`}
      style={{ width: size, height: size, fontSize: Math.max(11, size * 0.36) }}
    >
      {src ? (
        <img
          src={src}
          alt={student.name}
          className="h-full w-full object-cover"
          onError={() => setErrored(true)}
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
}
